import { addCandidateConstants } from "../../_constants";

const initialState = {};

// mentor profile
export const create_candidate_profile_recruiter_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case addCandidateConstants.CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST:
    case addCandidateConstants.UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case addCandidateConstants.CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateProfileDataCreate: action.payload,
      };

    case addCandidateConstants.UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateProfileDataUpdate: action.payload,
      };
    case addCandidateConstants.CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE:
    case addCandidateConstants.UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


